import type {MergeSuggestion, MergeSuggestionQueueItem} from '../types';

export const mapMergeSuggestionsToQueueItem = (
  mergeSuggestion: MergeSuggestion,
): MergeSuggestionQueueItem => {
  const {sourceId, targetId, type} = mergeSuggestion;

  return {
    link: `/${type.toLowerCase()}/${sourceId}/merge/${targetId}`,
    tooltip: `Hopp til neste forslag`,
  };
};
